import { City, ConfigurationResult } from '@mews-distributor/data-access';
import { keyById } from '@mews/fp';
import { createReducer } from '@mews/framework/redux';
import { FETCH_CONFIGURATIONS_SUCCEEDED } from '../../configuration/actionTypes';

const initialState: Record<string, City> = {};

export const citiesReducer = createReducer(initialState, {
    [FETCH_CONFIGURATIONS_SUCCEEDED]: (_state: Record<string, City>, { cities }: ConfigurationResult) =>
        keyById(cities),
});
